import { render, staticRenderFns } from "./units.vue?vue&type=template&id=8b6bc49c&"
import script from "./units.vue?vue&type=script&lang=js&"
export * from "./units.vue?vue&type=script&lang=js&"
import style0 from "./units.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports